export const CONTACT = {
  brand: 'Karasa',
  brandFull: 'Karasa · Khas Nusantara',
  whatsappPhone: '6282221116142',
  whatsappDisplay: '+62 822-2111-6142',
  instagramHandle: 'karasa.local',
  instagramUrl: 'https://instagram.com/karasa.local',
  tiktokHandle: '@karasa.local',
  tiktokUrl: 'https://tiktok.com/@karasa.local',
  email: 'karasa.local@gmail.com',
  location: 'Rancaekek, Bandung, Jawa Barat',
} as const

export type ContactConfig = typeof CONTACT
